import React, { createRef } from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import Render from '../render';

class Input extends React.Component {
  inputRef;

  static defaultProps = {
    type: 'text',
    autoComplete: 'off',
    error: false,
    selected: false,
    size: 'medium',
    mobileSize: 'medium',
  };

  constructor(props) {
    super(props);

    this.inputRef = createRef();
  }

  componentDidMount() {
    const { selected } = this.props;

    if (selected) {
      this.inputRef.current.select();
    }
  }

  render() {
    // eslint-disable-next-line yola/@typescript-eslint/no-unused-vars
    const { error, type, autoComplete, selected, size, mobileSize, ...otherProps } = this.props;
    const isMobile = bowser.mobile || bowser.tablet;
    const resultSize = isMobile ? mobileSize : size;

    return (
      <div
        className={classNames('ws-input', {
          'ws-input--error': error,
        })}
      >
        <Render if={type !== 'textarea'}>
          <input
            className={classNames('ws-input--element', `ws-input--${resultSize}`)}
            ref={this.inputRef}
            type={type}
            autoComplete={autoComplete}
            {...otherProps}
          />
        </Render>
        <Render if={type === 'textarea'}>
          <textarea
            className={classNames(
              'ws-input--element',
              'ws-input--textarea',
              `ws-input--textarea-${resultSize}`
            )}
            ref={this.inputRef}
            {...otherProps}
          />
        </Render>
      </div>
    );
  }
}

export default Input;
